<template>
    <div class="main-content__wizzard">
        <div class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                Create teams
            </h2>

            <div class="list-of-teams">
                <div v-for="team in organization.teams" :key="team.id" class="list-of-teams__item">
                    <h2 class="list-of-teams__team-name">{{team.name}}</h2>

                    <div class="list-of-teams__section" v-translate>Team leader:</div>
                    <div class="list-of-teams__team-leader">
                        <div class="my-people-member-ticker">
                            <div v-if="teamMember(team.leader).profile_photo" class="my-people-member-ticker__profile-image">
                                <img :src="teamMember(team.leader).profile_photo">
                            </div>
                            <div class="my-people-member-ticker__details">
                                <div class="my-people-member-ticker__name">{{teamMember(team.leader).first_name}} {{teamMember(team.leader).last_name}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="list-of-teams__section" v-translate>Team members:</div>
                    <div class="list-of-teams__team-members">
                        <div v-for="member in team.members" :key="member" class="my-people-member-ticker">

                            <div v-if="teamMember(member).profile_photo" class="my-people-member-ticker__profile-image">
                                <img :src="teamMember(member).profile_photo">
                            </div>

                            <div class="my-people-member-ticker__details">
                                <div class="my-people-member-ticker__name">{{teamMember(member).first_name}} {{teamMember(member).last_name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="list-of-teams__actions">
                        <button class="button button--small button--gray" @click="editTeam(team)" v-translate>Edit team</button>
                        <button @click="deleteTeam(team)" class="button button--small button--gray button--red-on-hover" v-translate>Remove team</button>
                    </div>
                </div>

                <button class="list-of-teams__item add-new-button" @click="addNewTeam()">
                    <div class="add-new-button__icon icon icon-plus"></div>
                    <div class="add-new-button__text" v-translate>
                        Add new <strong>team</strong>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex';
    import AddNewTeam from "../../views/popups/AddNewTeam";
    import axios from "axios";
    import {EventBus} from '../../event-bus';

    export default {
        name: 'plan-organization-step-two',
        data() {
            return {
                add_new_team_popup: AddNewTeam,
                organization: {},
                people: []
            }
        },
        props: {
            created_organization: {},
        },
        beforeMount: async function () {
            this.organization = this.created_organization
            this.people = (await axios.get('/api/navigator/people/')).data
        },
        methods: {
            ...mapActions([
                'openPopup',
                'setPopupPayload'
            ]),
            teamMember: function(member) {
                  return this.people.find(person => person.id == member)
            },
            reloadOrganization: async function () {
                this.organization = (await axios.get('/api/navigator/organizations/'+this.organization.id+'/')).data
            },
            editTeam: function(editable_team) {
                this.setPopupPayload(
                    {
                        organization: this.organization,
                        action: 'edit',
                        team: editable_team
                    }
                )
                this.openPopup(this.add_new_team_popup)
            },
            addNewTeam: function() {
                this.setPopupPayload(
                    {
                        organization: this.organization,
                        action: 'create'
                    })
                this.openPopup(this.add_new_team_popup)
            },
            deleteTeam: async function(team) {
                await axios.delete('/api/navigator/teams/' + team.id + '/')
                this.reloadOrganization()
            }
        },
        created: function () {
            EventBus.$on('reload-organization', this.reloadOrganization)
        },
        beforeDestroy: function () {
            EventBus.$off('reload-organization')
        }
    }
</script>
